import posthog from "posthog-js";
import { posthogId } from "../../constants.ts";

const ph = posthog.init(posthogId, { api_host: "https://app.posthog.com" });

export const logError = (error: Error | { message: string }) => {
  console.error(error);
  const { message, stack } = error instanceof Error
    ? error
    : new Error(error.message);
  ph.capture("Client side error", { message, stack });
};
